module.exports = "<div class=\"container\">\n  <div domain-detail=\"domainDetailCtrl.domain\"></div>\n</div>\n\n";